import { gql } from 'urql';

export const LIST_INGRESOS = gql`
  query StockEntradas($filter: StockMovimientoFilter) {
    stockEntradas(filter: $filter) {
      items { id fecha tipo cliente clienteId remito usuario usuarioId cantidadTotal }
      total page pageSize
    }
  }
`;

export const LIST_EGRESOS = gql`
  query StockSalidas($filter: StockMovimientoFilter) {
    stockSalidas(filter: $filter) {
      items { id fecha tipo cliente clienteId remito usuario usuarioId cantidadTotal }
      total page pageSize
    }
  }
`;

export const GET_MOVIMIENTO = gql`
  query GetMovimiento($id: ID!) {
    stockMovimiento(id: $id) {
      id
      fecha
      hora
      tipo
      cliente
      clienteId
      remito
      usuario
      usuarioId
      cantidadTotal
      detalles {
        id
        articuloId
        cantidad
        lote
        vencimiento
        ubicacionId
        ubicacionDestinoId
        articulo {
          codigo
          nombre
        }
      }
    }
  }
`;

export const REGISTRAR_INGRESO = gql`
  mutation RegistrarIngreso($input: RegistrarIngresoInput!) {
    registrarIngreso(input: $input) { id }
  }
`;

export const REGISTRAR_EGRESO = gql`
  mutation RegistrarEgreso($input: RegistrarEgresoInput!) {
    registrarEgreso(input: $input) { id }
  }
`;

export const TRANSFERIR_STOCK = gql`
  mutation TransferirStock($input: TransferirStockInput!) {
    transferirStock(input: $input)
  }
`;
